import React from 'react';
import { __ } from 'i18n-for-browser';
import connect from "react-redux/es/connect/connect";

import DifficultyAwareComponent from "../../DifficultyAwareComponent";
import BudgetHeaderDropdown from "./BudgetHeaderDropdown";
import {
  calculateBudgetPRO, calculateSavingsAndLoans, calculateBudgetBASIC
} from '../../../helpers/calculationsHelper';
import { getUnreadGifts } from '../../../helpers/bankHelper'

import { getSelectedPolicyChoicesCount, getTotalCosts } from '../../../helpers/policyChoiceHelper';
import Treasury from "../../../assets/img/icons/budget.png";
import Bank from "../../../assets/img/icons/bank.png";
import Beleidskeuze from "../../../assets/img/icons/beleidskeuze.svg";

import gameStateInputFromActions from '../../../actions/gameStateInput';
import { getContent } from "../../../helpers/popupHelper";;

const { updateMyState } = gameStateInputFromActions;

let previousGlobas = 9999;
class BudgetHeader extends DifficultyAwareComponent {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      previousGlobas: 9999,
      closedNegativeBudgetPopup: false,
    };

    this.sendGlobas = null;
  }

  renderLaag() {
    const { gameState, gameStateInput, myState, policyChoice, project } = this.props;
    const { ministerieGlobaVerdeling } = myState;
    if (gameStateInput === undefined) return;
    const loanSpare = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetBASIC(gameState, myState.policyChoices, ministerieGlobaVerdeling, loanSpare, policyChoice);
    const bankActive = window.location.pathname.toLowerCase().substr(1) === 'bank';
    const bankEnabled = project && project.bankEnabled !== false;
    // Dit is alleen voor laag! Dus is niet "vergeten" bij pro.
    // const showNegativeBudgetPopup = globas < 0 && gameState.roundData.roundNumber <= 4 && !this.state.closedNegativeBudgetPopup;
    return (
      <div className={`budget-header low-budget-header${bankEnabled ? '' : ' no-bank'}`}>
        <BudgetHeaderDropdown history={this.props.history} title={`${globas}`} doubleTitle={__('sim_budget')} icon={Treasury} dropdownTitle={__('sim_budget')}>
          <ul>
            <li>{__('sim_overheidsinkomsten')} <span>{Math.abs(gameState.totalGameStateSum.globas)} {__('sim_miljard')} {__('sim_globas')}</span></li>
            <li className={'min'}>{__('sim_overheidsuitgaven')} <span>{Math.abs(getTotalCosts(myState.policyChoices, policyChoice) +
              Object.values(ministerieGlobaVerdeling)
                .filter((i) => parseInt(i, 10))
                .reduce((acc, i) => acc + i, 0))} {__('sim_miljard')} {__('sim_globas')}</span></li>
            {bankEnabled ? (
              <li className={loanSpare > 0 ? 'plus' : 'min'}>{__('sim_saldo_sparen_lenen')} <span>{Math.abs(loanSpare)} {__('sim_miljard')} {__('sim_globas')}</span></li>
            ) : null}
            <li className={'divider'}>-------------------------------</li>
            <li><strong>{__('sim_resterend_budget')} <span>{globas} {__('sim_miljard')} {__('sim_globas')}</span></strong></li>
          </ul>
        </BudgetHeaderDropdown>

        {bankEnabled ? (
          <BudgetHeaderDropdown history={this.props.history} title={__('sim_bank')} icon={Bank} bank={true} active={bankActive} />
        ) : null}
        {/*{showNegativeBudgetPopup ? (*/}
        {/*  <PopUp*/}
        {/*    id={`${desktop ? 'd' : 'm'}lgmstap3negatiefbudget_${gameState.roundData.roundNumber === 4 ? 2 : 1}`}*/}
        {/*    showPopUp={true}*/}
        {/*    showIfUnread={`lgmstap3negatiefbudget_${gameState.roundData.roundNumber}`}*/}
        {/*    closePopUpClick={() => { this.setState({ closedNegativeBudgetPopup: true }); }}*/}
        {/*  />*/}
        {/*) : null}*/}
      </div>
    )
  }

  renderHoog() {
    const { gameState, gameStateInput, myState, dispatch, project } = this.props;
    const { debitCredit } = gameStateInput.myState;

    const { policyChoices, ministerieGlobaVerdeling } = myState;
    if (gameStateInput === undefined) return;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetPRO(gameState, gameStateInput, policyChoices, myState.ministerieGlobaVerdeling, savingsAndLoans);

    if (globas !== previousGlobas) {
      clearTimeout(this.sendGlobas);
      previousGlobas = globas;
      this.sendGlobas = setTimeout(() => {
        dispatch(updateMyState(
          {
            debitCredit: { ...debitCredit, globas: globas }
          }
        ));
      }, 1000);
    }

    const numChoices = getSelectedPolicyChoicesCount(policyChoices);
    const showPolicyChoices = project && project.minPolicyChoices > 0;

    let unreadGifts = getUnreadGifts(gameStateInput);
    const bankUnread = Object.values(gameStateInput.myState.debitCredit).some(dc => dc.confirmed && dc.unread) || unreadGifts;
    const bankActive = window.location.pathname.toLowerCase().substr(1) === 'bank';
    const bankEnabled = project && project.bankEnabled !== false;
    return (
      <div className={`budget-header${bankEnabled ? '' : ' no-bank'}`}>
        <BudgetHeaderDropdown history={this.props.history} title={`${globas}`} icon={Treasury} dropdownTitle={__('sim_budget')}>
          <ul>
            <li>{__('sim_overheidsinkomsten')} <span>{gameState.totalGameStateSum.globas} {__('sim_miljard')} {__('sim_globas')}</span></li>
            <li className={'min'}>{__('sim_overheidsuitgaven')} <span>{Object.values(policyChoices).reduce((acc, o) => acc + o.globas, 0) +
              Object.values(ministerieGlobaVerdeling)
                .filter((i) => parseInt(i, 10))
                .reduce((acc, i) => acc + i, 0)} {__('sim_miljard')} {__('sim_globas')}</span></li>
            {bankEnabled ? (
              <li className={savingsAndLoans > 0 ? 'plus' : 'min'}>{__('sim_saldo_sparen_lenen')} <span>{Math.abs(savingsAndLoans)} {__('sim_miljard')} {__('sim_globas')}</span></li>
            ) : null}
            <li className={'divider'}>-------------------------------</li>
            <li><strong>{__('sim_resterend_budget')} <span>{globas} {__('sim_miljard')} {__('sim_globas')}</span></strong></li>
          </ul>
        </BudgetHeaderDropdown>

        {bankEnabled ? (
          <BudgetHeaderDropdown history={this.props.history} title={__('sim_bank')} icon={Bank} bank={true} notification={bankUnread} active={bankActive} />
        ) : null}

        {showPolicyChoices ? (
          <BudgetHeaderDropdown history={this.props.history} title={`${numChoices}/10`} icon={Beleidskeuze} >
            <span dangerouslySetInnerHTML={{ __html: getContent('dhgmstap3beleidskeuzes', this.props.gameState.language).replace(/h1/g, 'h3') }}></span>
            <ol className={'policy-list'}>
              {Object.values(policyChoices).map(item => (
                <li key={item.nummer + item.ministry}><div className={'wrap'}><span className={'left'}>{__(item.ministry)} - {item.title}</span><span className={'right'}>{item.globas} {__('sim_miljard')}</span></div></li>
              ))}

            </ol>
            <ul>
              <li className={'divider'}>
                {numChoices ? '-------------------------------' : ''}
              </li>
              <li><strong>{__('sim_totale_kosten_beleidskeuzes')} <span>{Object.values(policyChoices).reduce((accumulator, item) => { return accumulator + item.globas }, 0)} {__('sim_miljard')}</span></strong></li>
              <br />
              <li><strong>{__('sim_resterende_beleidskeuzes')} <span>{10 - numChoices}</span></strong></li>
            </ul>
          </BudgetHeaderDropdown>
        ) : null}
      </div>
    )
  }
}

export default connect(({ gameState, gameStateInput, project, policyChoice }) => ({ gameState, gameStateInput, myState: gameStateInput.myState, project, policyChoice }))(BudgetHeader);



// WEBPACK FOOTER //
// ./src/components/elements/StepThree/BudgetHeader.js